// extracted by mini-css-extract-plugin
module.exports = {"root":"SelectPayment_root__2AfXL","text":"SelectPayment_text__3Wfrb","title":"SelectPayment_title__LBvBd","btn":"SelectPayment_btn__2sKq5"};